<eup-error-page statusCode="400"
                errorHeader="{{'Errors.Error_400_Title' | translate}}"
                errorDescription="{{'Errors.Error_400_Message' | translate}}">
</eup-error-page>